import React from 'react'
import { VStack, Text } from '@chakra-ui/react'
import { EBreakPoint } from 'enums/theme'
import useBreakPoint from 'hooks/useBreakPoint'
import { Controller, useFormContext } from 'react-hook-form'
import CustomDatePickerWithMask from 'components/CustomDaterRangePickerWithMask'
import FormInput from 'components/FormInput'
import LandlordPhoneInput from '../LandlordPhoneInput'

const PICKER_DATE_FORMAT: string = 'MM/dd/yyyy'
const DATE_INPUT_FORMAT: string = '##/##/#### - ##/##/####'
const DATE_INPUT_MASK: string[] = ['M', 'M', 'D', 'D', 'Y', 'Y', 'Y', 'Y', 'M', 'M', 'D', 'D', 'Y', 'Y', 'Y', 'Y']

const PreviousLandlordInformation = () => {
  const { control, setValue } = useFormContext()
  const isNotDesktop: boolean = useBreakPoint(EBreakPoint.BASE, EBreakPoint.LG)
  return (
    <VStack width="full" spacing={4} alignItems="flex-start">
      <Text fontWeight={600} color="gray.700">
        Previous Landlord Information
      </Text>
      <VStack width="full" spacing={8}>
        <FormInput
          height={isNotDesktop ? '48px' : '40px'}
          name="previousLandlordName"
          label="Landlord Name / Company Name"
          placeholder="Enter Landlord Name / Company Name"
          autoComplete="off"
        />
        <FormInput name="previousLandlordPhoneNumber" label="Landlord Phone Number">
          <LandlordPhoneInput />
        </FormInput>
        <FormInput
          height={isNotDesktop ? '48px' : '40px'}
          name="previousLandlordEmail"
          label="Landlord Email Address (optional)"
          placeholder="Enter Landlord email address"
          type="email"
          autoComplete="off"
          isRequired={false}
        />
        <FormInput name="previousMoveDate" label="Move-in - Move-out date (optional)">
          <Controller
            name="previousMoveDate"
            control={control}
            render={(previousMoveDateProps) => {
              return (
                <CustomDatePickerWithMask
                  name="previousMoveDate"
                  dateFormat={PICKER_DATE_FORMAT}
                  inputFormat={DATE_INPUT_FORMAT}
                  inputMask={DATE_INPUT_MASK}
                  inputPlaceholder="__/__/____
                  - __/__/____"
                  height={isNotDesktop ? '48px' : '40px'}
                  setValue={setValue}
                  {...previousMoveDateProps}
                />
              )
            }}
          />
        </FormInput>
      </VStack>
    </VStack>
  )
}

export default PreviousLandlordInformation
